import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";

import { SET_AUTHOR_ID, SET_TICKET_DETAILS, SET_TICKET_LIST_RELOAD } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import TumbnailImg from "./TumbnailImg";
import DisplayImage from "./DisplayImage";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import attactment from "../../svg/additional.svg";

import api from "../../api/api";

class TicketDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: [],
      commentList: [],
      closeMessage: false,
      displayImage: false,
      imageNo: 0,
      fileToDisplay: null,
      linkId: this.props.match.params.id,
      displayErrorPopup: false,
      next_page: null,
      scrolling: false
    };
  }

  /**
   * this is for history goback  or close add new Message
   */
  goBack = () => {
    if (this.state.closeMessage) {
      this.setState({
        closeMessage: false
      });
    } else if (this.state.displayImage) {
      this.setState({
        displayImage: false
      });
    } else {
      this.props.history.goBack();
    }
  };
  /**
   * for getting the close option for the ticket
   */
  moreOptionCLick = () => {
    this.setState({
      closeMessage: true
    });
  };

  updateHelpTS = () => {
    const { countryCode, userId, userIdv2 } = this.props;

    if (userIdv2) {
      const obj = {
        helpTS: new Date(),
        userId: userIdv2
      };
      api
        .updateUserDatav2(obj)
        .then(data => {
          const { helpTS } = data;
          this.props.updateTS(helpTS);
        })
        .catch(error => {
          this.setState({
            displayErrorPopup: true
          });
          api.displayHideLoader();
        });
    } else {
      const obj = {
        helpTS: new Date(),
        countryCode,
        userId: userIdv2
      };
      api
        .updateUserDatav2(obj)
        .then(data => {
          const { helpTS } = data;
          this.props.updateTS(helpTS);
        })
        .catch(error => {
          this.setState({
            displayErrorPopup: true
          });
          api.displayHideLoader();
        });
    }
  };

  /**
   * add new message click
   */
  onCloseOptionClick = type => {
    this.setState({
      closeMessage: false
    });
    if (type === "close") {
      const customFields = {
        "cf_user_phone_number": `${this.props.countryCode} ${this.props.mobile}`,
        "cf_user_id": this.props.userIdv2,
        "cf_city": this.props.city,
        "cf_user_name": this.props.name
      };
      let dataToSend = {
        status: 5,
        comment: "",
        imageArray: [],
        customFields: customFields
      };
      api.displayMainLoader();
      api
        .updateTicket(this.state.linkId, dataToSend)
        .then(data => {
          this.props.ticketUpdated();
          api.displayHideLoader();
          this.goBack();
        })
        .catch(error => {
          console.log(error);
          this.setState({
            displayErrorPopup: true
          });
        });
    }
  };

  /**
   * to display image in screen
   */
  onTumbnailClick = id => {
    let imageUrl = "";
    this.state.commentList.forEach(element => {
      element.attachments.find(searchVal => {
        if (searchVal.id === id) {
          imageUrl = searchVal.content_url;
        }
      });
    });
    this.setState({
      displayImage: true,
      imageNo: id,
      fileToDisplay: imageUrl
    });
  };

  loadTicketDetails() {
    api
    .ticketsDetails(this.state.linkId, this.state.next_page)
    .then(data => {
      let list = this.state.commentList;
      let initialTicketQuery = {
        id: data.data.requester_id,
        user_id: data.data.requester_id,
        body_text: data.data.description_text,
        created_at:data.data.created_at,
        author_id: data.data.requester_id,
        attachments: data.data.attachments || [],
        name: data.data.requester.name || "Playo",        
      }
      console.log("safa" + JSON.stringify(initialTicketQuery))
      list.push(initialTicketQuery);
      this.setState({
        commentList: list,
        userId: this.state.userId.concat([{
          agent: false,
          id: data.data.requester_id,
          name: data.data.requester.name || "Playo",
          user_id: data.data.requester_id,
        }]),
      });

      this.loadComments()
    })
    .catch(error => {

    })
  }

  /**
   * call zendesk api to get detaisl of the ticket
   */
  loadComments() {
    api
      .conversations(this.state.linkId, this.state.next_page)
      .then(data => {
        console.log(data)
        let list = this.state.commentList;
        let conversations = data.data.filter(comment => comment.private === false);
        this.setState({
          commentList: list.concat(conversations),
          next_page: data.next_page ? data.next_page : null,
          scrolling: false,
        });
        for (let i = 0; i < conversations.length; i++) {
          if (!conversations[i].incoming) {
            this.props.setAuthorId(conversations[i].user_id);
            break;
          }
        }
        console.log("ticket conversations" + data.data)
        console.log("ticket details conversations" + list)
        api.displayHideLoader();
      })
      .catch(error => {
        this.setState({
          displayErrorPopup: true
        });
        console.log(error);
        api.displayHideLoader();
      });
  }

  /**
   * if the ticket title and status is there in store than it will do the api call
   * and send the details to the store
   */
  loadTicketStatusAndTitle() {
    api
      .getTicketStatusAndTitle(this.state.linkId)
      .then(data => {
        let dataToSend = {
          title: `Support Ticket #${data.data.id}`,
          status: data.data.status
        };
        this.props.setHeadetDetails(dataToSend);
        this.loadTicketDetails();
      })
      .catch(error => {
        console.log(error);
        api.displayHideLoader();
      });
  }

  /**
   * on Error Message close click
   */
  errorCloseCLick = () => {
    this.setState({
      displayErrorPopup: false
    });
  };

  handleScroll = () => {
    const scrolling = this.state.scrolling;
    const nextPage = this.state.next_page;

    if (scrolling) {
      return;
    }

    if (nextPage == null) {
      return;
    }

    const secondLastElement = document.querySelector(".ticket-comment-container:nth-last-child(2)");
    const lastOffset = secondLastElement.offsetTop + secondLastElement.clientHeight;
    const pageOffset = window.pageYOffset + window.innerHeight;
    const bottomOffset = 50;
    if (pageOffset > lastOffset - bottomOffset) {
      this.setState(
        {
          scrolling: true
        },
        () => {
          this.loadComments();
        }
      );
    }
  };

  /**
   * this method is called when the component is loaded
   */
  componentDidMount() {
    api.displayMainLoader();
    if (this.props.headerMessage.title === "") {
      this.loadTicketStatusAndTitle();
    } else {
      this.loadTicketDetails();
    }
    this.scrollListner = window.addEventListener("scroll", this.handleScroll);
    this.updateHelpTS();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    return (
      <div>
        <HelpAndSupportHeader
          displayMessage={this.props.headerMessage}
          back={this.goBack.bind(this)}
          moreOption={this.moreOptionCLick.bind(this)}
        />
        {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : ""}
        {this.state.closeMessage ? <CloseTicketOption onCloseOptionClick={this.onCloseOptionClick.bind(this)} /> : ""}
        <div className="body-container">
          {this.state.commentList.map(comment => {
            return (              
              <DisplayComment
                key={comment.id}
                userId={this.state.userId}
                displayComment={comment}
                onTumbnailClick={this.onTumbnailClick.bind(this)}
              />
            );
          })}
          {(!this.props.headerMessage.moreOptionhidden && this.state.userId && this.state.userId.length > 0 && this.state.userId[0].id) ? <AddNewMessage linkId={this.state.linkId} userId={this.state.userId[0].id} /> : ""}
        </div>
        {this.state.displayImage ? (
          <DisplayImage
            no={this.state.imageNo}
            image={this.state.fileToDisplay}
            displayDeleteBtn={false}
            back={this.goBack.bind(this)}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const DisplayComment = props => {
  let desc = new Date(props.displayComment.created_at);
  let descDisplay = moment(desc).calendar({
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    lastDay: "[Yesterday]",
    lastWeek: "[Last] dddd",
    sameElse: "L"
  });
  if (desc < moment().subtract(7, "d")) {
    descDisplay = moment(desc).format("DD/MM/YYYY, hh:mm a");
  }
  let userName = "Playo";
  props.userId.forEach(element => {
    console.log("element" + JSON.stringify(element))
    console.log("props" + JSON.stringify(props.displayComment))
    if (!element.agent && element.user_id === props.displayComment.user_id) userName = element.name;
  });

  return (
    <div className="ticket-comment-container">
      <div className="help-support-card-title" style={{ fontSize: "14px" }}>
        {userName}
      </div>
      <div className="help-support-card-desc" style={{ fontSize: "10px" }}>
        {descDisplay}
      </div>
      <div className="ticket-comment-box">{props.displayComment.body_text}</div>
      {props.displayComment.attachments && props.displayComment.attachments.map(image => {
        return (
          <TumbnailImg
            image={image}
            key={image.id}
            no={image.id}
            onTumbnailClick={props.onTumbnailClick.bind(this)}
            imageLink={true}
          />
        );
      })}
    </div>
  );
};

const AddNewMessage = props => {
  return (
    <Link className="ticket-attactment-icon-area" to={"/newcomment/" + props.linkId + "?userId=" + props.userId}>
      <img src={attactment} alt="" className="ticket-attactment-icon" />
      <label className="ticket-attactment-label">Add a message</label>
    </Link>
  );
};

const CloseTicketOption = props => {
  return (
    <div className="popup-back">
      <div className="popup-body-container">
        <div className="popup-title" style={{ marginTop: "30px" }}>
          Close Ticket
        </div>
        <div className="popup-description">Do you want to close this ticket ?</div>
        <input
          type="button"
          className="popup-btn"
          value="Close"
          onClick={props.onCloseOptionClick.bind(this, "close")}
        />
        <input
          type="button"
          className="popup-cancel-btn"
          value="Cancel"
          onClick={props.onCloseOptionClick.bind(this, "cancel")}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    headerMessage: {
      title: state.headerTitle,
      description: "",
      backIcon: true,
      moreOptionhidden: state.ticketStatus === "closed" ? true : false,
      searchOptionHidden: true
    },
    userId: state.userId,
    userIdv2: state.userIdv2,
    countryCode: state.countryCode,
    mobile: state.mobile,
    city: state.city,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setAuthorId: authorId => {
      dispatch({
        type: SET_AUTHOR_ID,
        payload: authorId
      });
    },
    setHeadetDetails: headerData => {
      dispatch({
        type: SET_TICKET_DETAILS,
        payload: headerData
      });
    },
    ticketUpdated: () => {
      dispatch({
        type: SET_TICKET_LIST_RELOAD,
        payload: true
      });
    },
    updateTS: helpTS => {
      dispatch({
        type: "UPDATE_HELPTS",
        payload: helpTS
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketDetails);



// WEBPACK FOOTER //
// ./src/components/Tickets/TicketDetails.js